import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Refer a Friend, Get a Free Shipment | Ship&Play',
  description:
    "Love Ship&Play? Share it. Refer your friends and you'll both save on shipping. " +
    "$10 off for them, a free shipment for you - it's a win-win.",
  alternates: {
    canonical: 'https://www.shipplay.com/refer',
  },
}

export default metadata
